module.exports = __webpack_public_path__ + "static/media/alex.d51a2db6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alex.jpg
// module id = 89
// module chunks = 0